import { render } from "./Modal.vue?vue&type=template&id=70a46a6e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/ui/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a46a6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a46a6e', __exports__)) {
    api.reload('70a46a6e', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=70a46a6e", () => {
    api.rerender('70a46a6e', render)
  })

}


export default __exports__